export const appVersion = '1.5.2';

// password configuration
export const specialChars = '!@#$%& *()][}{|,:;<>/?+-_=';
export const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const name = 'Urząd Miasta i Gminy Wronki';
export const description = 'Portal e-usług';

// export const appLogoTopUrl = '/img/Herb_Polski.svg';
// export const appLogoBottomUrl = '/img/icons/godlo-12.svg';

export const appLogoTopUrl = '/img/logo.png';
export const appLogoBottomUrl = '/img/herb.png';

export const showFooterEULogotypes = true;
